const shared={
    check:'Events',
    title:'Event',
    url:'event',
    historydetail:"groupsDetail",
    addApi:'api/event/create',
    editApi:'api/event/edit',
    detailApi:'api/event/details',
    listApi:'api/user/group-events',
    statusApi:'api/event/edit',
    mailApi:"api/send-email/event",
    deleteApi:'api/event/delete'
}

export default shared